import { AxiosResponse } from 'axios';
import { apiV2 } from './http';
import { ILoadSoftwaresResponse } from './interfaces/software';

export function loadSoftwaresAndServices(): Promise<
  AxiosResponse<ILoadSoftwaresResponse>
> {
  return apiV2.get<ILoadSoftwaresResponse>('softwares');
}
